module.exports = __webpack_public_path__ + "static/media/28.42e06897.JPG";